import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SystemService } from '../../../core/admin/system.service';
import { ComplianceReport } from '../../../core/admin/system.types';
import { IconComponent } from '../../../shared/icon/icon';

@Component({
  selector: 'app-compliance',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    RouterLink,
    IconComponent,
  ],
  templateUrl: './compliance.html',
  styleUrl: './compliance.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplianceComponent implements OnInit {
  private readonly systemService = inject(SystemService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly report = signal<ComplianceReport | null>(null);
  protected readonly loading = signal(true);
  protected readonly error = signal(false);

  ngOnInit(): void {
    this.load();
  }

  protected load(): void {
    this.loading.set(true);
    this.error.set(false);
    this.cdr.markForCheck();

    this.systemService
      .getCompliance()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (report) => {
          this.report.set(report);
          this.loading.set(false);
          this.cdr.markForCheck();
        },
        error: () => {
          this.loading.set(false);
          this.error.set(true);
          this.cdr.markForCheck();
        },
      });
  }

  protected statusLabel(status: string): string {
    switch (status) {
      case 'open':
        return 'Open';
      case 'in-progress':
        return 'In progress';
      case 'resolved':
        return 'Resolved';
      case 'needs-verification':
        return 'Needs verification';
      default:
        return status;
    }
  }
}
